import React, { forwardRef, Fragment } from 'react';

import BenefitsFeatures from './BenefitsFeatures';
import BenefitsTeleHealth from './BenefitsTeleHealth';
import BenefitsCircle from './BenefitsCircle';
import BenefitsPharmacy from './BenefitsPharmacy';
import BenefitsBanner from './BenefitsBanner';
import BenefitsHero from './BenefitsHero';

import BenefitsWellness from '@/components/Benefits/BenefitsWellness';
import BenefitsTabs from '@/components/Benefits/BenefitsTabs';

const Benefits = () => {
  return (
    <Fragment>
      <BenefitsHero />
      <BenefitsFeatures />
      <BenefitsTeleHealth />
      <BenefitsTabs />
      <BenefitsPharmacy />
      <BenefitsCircle />
      <BenefitsWellness />
      <BenefitsBanner />
    </Fragment>
  );
};

export default forwardRef(Benefits);
